import { ELIGIBILITY_TYPE } from '../const/eligibilityType';
import { getValues } from '../xform';
export const getPaymentFlowFormValues = (context) => {
    const { form, apiMachineRef } = context;
    const { alternatePaymentMethodsQueryResult, paymentMethodsQueryResult } = apiMachineRef.getSnapshot().context;
    const paymentMethods = [
        ...paymentMethodsQueryResult.data.paymentMethods,
        ...alternatePaymentMethodsQueryResult.data.paymentMethods
    ];
    const paymentForm = getValues(form.getSnapshot().context.actors);
    const paymentMethod = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.find((method) => {
        return `${method === null || method === void 0 ? void 0 : method.id}` === (paymentForm === null || paymentForm === void 0 ? void 0 : paymentForm.paymentMethod);
    });
    return [paymentForm.paymentOption, paymentMethod];
};
export const constructEligibilityQueryParams = (featureFlag) => {
    const paymentCapabilityEligibilityArr = [
        ELIGIBILITY_TYPE.ALLOWED_PAYMENT_METHODS,
        ELIGIBILITY_TYPE.AUTOPAY
    ];
    if (featureFlag.isWaivedInterestEnabled) {
        paymentCapabilityEligibilityArr.push(ELIGIBILITY_TYPE.PAYMENT_OPTION);
    }
    if (featureFlag.isSecuredInstallmentEnabled) {
        paymentCapabilityEligibilityArr.push(ELIGIBILITY_TYPE.ONE_TIME_PAYMENT);
    }
    return paymentCapabilityEligibilityArr;
};
